export enum AddClientFormFields {
  OrganizationPoc = 'organizationPoc',
  GlobalGuardianPoc = 'globalGuardianPoc',
  OrganizationContracts = 'organizationContracts',
}
